<template>
  <div class="loadingView" v-if="loadingForm">
    <LoadingList v-model="loadingForm" text="Carregando dados." />
  </div>
  <div v-else>
    <RequiredFieldsMessage />
    <div class="wrap-informed">
      <div
        v-for="(value, index) in value"
        :key="index"
        :style="{ position: 'relative', zIndex: 10 - (index + 1) }"
      >
        <h5
          style="margin-left: 5px; cursor: pointer"
          v-b-toggle="`accordion-${index + 1}`"
          v-if="value.previousInformed === 'Não'"
        >
          {{ value.type }}
        </h5>
        <h5 style="margin-left: 5px" v-else>
          {{ value.type }}
        </h5>

        <b-row
          class="information row mb-2"
          :style="{ position: 'relative', zIndex: 10 - (index + 1) }"
        >
          <b-col md="4">
            <b-form-group class="required">
              <label for="">Informações preenchidas anteriormente</label>
              <multiselect
                open-direction="bottom"
                v-model="value.previousInformed"
                :options="options.boolean"
                :multiple="false"
                class="required"
                placeholder="Selecione"
                selectLabel=""
                @input="setPreviousSelected($event, index)"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" v-if="value.previousInformed === 'Sim'">
            <b-form-group class="required">
              <label for="">Repetir dados de:</label>
              <multiselect
                open-direction="bottom"
                v-model="value.formData"
                :options="contractorList"
                :multiple="false"
                class="required"
                required
                label="name"
                placeholder="Selecione"
                selectLabel=""
                @select="onSelectFiliation($event, index)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="value.previousInformed === 'Não'" class="information row">
          <b-col md="12">
            <b-card-header
              header-tag="header"
              role="tab"
              class="title-collapse"
            >
            </b-card-header>
            <b-collapse
              :id="`accordion-${index + 1}`"
              v-model="accordionStates[index]"
              role="tabpanel"
            >
              <b-row>
                <b-col md="2" v-if="!value.deceased && !value.not_applicable">
                  <ProfilePhoto
                    class="form-group required photo-field"
                    :modalId="`filiation-${index}`"
                    :photo="
                      typeof value.formData.photo !== 'string'
                        ? value.formData.photoPreview
                        : value.formData.photo
                    "
                    :callback="(photo) => setNewPhoto(photo, index)"
                  />
                </b-col>
                <b-col>
                  <b-row class="mb-3">
                    <b-col v-if="!value.not_applicable" md="4">
                      <b-check
                        v-model="value.deceased"
                        @change="setDeceased($event, index)"
                        >Filiação é Falecido(a)</b-check
                      >
                    </b-col>

                    <b-col v-if="!value.deceased && index == 1" md="3">
                      <b-check
                        v-model="value.not_applicable"
                        @change="setNotApplicable($event, index)"
                        >Não Há</b-check
                      >
                    </b-col>
                  </b-row>
                  <b-row v-if="value.not_applicable" class="mb-3">
                    <b-col>
                      <b-alert show variant="warning">
                        <strong>Importante:</strong> esta opção é exclusiva
                        para crianças com o registro de apenas um responsável
                        na certidão de nascimento.
                      </b-alert>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col v-if="!value.not_applicable">
                      <b-form-group class="required">
                        <label for="label">Relação com o aluno</label>
                        <multiselect
                          open-direction="bottom"
                          v-model="value.formData.relationship"
                          :options="options.relationships"
                          :multiple="false"
                          placeholder="Selecione"
                          class="required"
                          selectLabel=""
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="8">
                      <StandardInput
                        v-if="!value.not_applicable"
                        v-model="value.formData.name"
                        class="required"
                        type="text"
                        name="student-custody"
                        label="Nome Completo"
                        :error="nameStudantValidate"
                        labelError="Digite nome e sobrenome"
                        validateFullName
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group
                        class="required"
                        v-if="!value.deceased && !value.not_applicable"
                      >
                        <label for="label">Detentor da guarda do aluno</label>
                        <multiselect
                          open-direction="bottom"
                          v-model="value.formData.is_guardian"
                          :options="options.boolean"
                          :multiple="false"
                          placeholder="Selecione"
                          selectLabel=""
                        />
                      </b-form-group>
                    </b-col>

                    <b-col v-if="!value.deceased && !value.not_applicable">
                      <StandardInput
                        v-model="value.formData.occupation"
                        class="required"
                        type="text"
                        name="occupation"
                        label="Ocupação"
                      />
                    </b-col>

                    <b-col md="4">
                      <StandardInput
                        v-if="!value.deceased && !value.not_applicable"
                        v-model="value.formData.workplace"
                        class="required"
                        type="text"
                        name="student-custody"
                        label="Local de trabalho"
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="8">
                      <StandardInput
                        v-if="!value.deceased && !value.not_applicable"
                        v-model="value.formData.talents"
                        type="text"
                        name="activities"
                        label="Habilidades/Talentos que possam contribuir com a Escola da Serra"
                        :required="false"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row
                class="group"
                v-if="!value.deceased && !value.not_applicable"
              >
                <b-col>
                  <h5>Dados de endereço</h5>
                </b-col>
              </b-row>
              <b-row v-if="!value.deceased && !value.not_applicable">
                <b-col md="3">
                  <b-form-group class="required">
                    <label for="">Endereço igual ao do aluno</label>
                    <multiselect
                      open-direction="bottom"
                      v-model="sameAddress[index]"
                      :options="options.boolean"
                      :multiple="false"
                      placeholder="Selecione"
                      selectLabel=""
                      @input="resetAddressForm(index)"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <template v-if="sameAddress[index] == 'Não'">
                <b-row class="" v-if="!value.deceased && !value.not_applicable">
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.cep"
                      class="required"
                      type="text"
                      name="cep"
                      label="CEP"
                      required
                      v-mask="'#####-###'"
                      @onchange="getAddress(value.formData.Address.cep, index)"
                    />
                  </b-col>
                  <b-col>
                    <b-form-group class="required">
                      <label for="label">Estado</label>
                      <multiselect
                        open-direction="bottom"
                        v-model="value.formData.Address.state"
                        :options="states"
                        :multiple="false"
                        placeholder="Selecione um estado"
                        selectLabel=""
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.city"
                      class="required"
                      type="text"
                      name="city"
                      label="Cidade"
                      required
                    />
                  </b-col>
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.neighborhood"
                      class="required"
                      type="text"
                      name="neighborhood"
                      required
                      label="Bairro"
                    />
                  </b-col>
                </b-row>
                <b-row v-if="!value.deceased && !value.not_applicable">
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.street"
                      class="required"
                      type="text"
                      name="address"
                      required
                      label="Endereço"
                    />
                  </b-col>
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.number"
                      class="required"
                      type="text"
                      required
                      name="number"
                      label="Número"
                    />
                  </b-col>
                  <b-col>
                    <StandardInput
                      v-model="value.formData.Address.complement"
                      type="text"
                      name="complement"
                      label="Complemento"
                      :required="false"
                    />
                  </b-col>
                  <b-col> </b-col>
                </b-row>
              </template>

              <b-row
                class="group"
                v-if="!value.deceased && !value.not_applicable"
              >
                <b-col>
                  <h5>Contatos</h5>
                </b-col>
              </b-row>
              <b-row v-if="!value.deceased && !value.not_applicable">
                <b-col>
                  <StandardInput
                    v-model="value.formData.phone1"
                    class="required"
                    type="text"
                    name="phone-1"
                    label="Telefone 1"
                    v-mask="'(##) #####-####'"
                  />
                </b-col>
                <b-col>
                  <StandardInput
                    v-model="value.formData.phone2"
                    :required="false"
                    type="text"
                    name="phone-2"
                    label="Telefone 2"
                    v-mask="'(##) #####-####'"
                  />
                </b-col>
                <b-col>
                  <StandardInput
                    v-model="value.formData.phone_commercial"
                    :required="false"
                    type="text"
                    name="commercial-phone"
                    label="Telefone Comercial"
                    v-mask="'(##) #####-####'"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!value.deceased && !value.not_applicable">
                <b-col md="4">
                  <StandardInput
                    v-model="value.formData.email"
                    class="required"
                    type="email"
                    name="email"
                    label="Seu e-mail"
                  />
                </b-col>
              </b-row>
              <!-- Group -->

              <!-- Group -->
              <b-row
                class="group"
                v-if="!value.deceased && !value.not_applicable"
              >
                <b-col>
                  <h5>Documentos</h5>
                </b-col>
              </b-row>
              <b-row v-if="!value.deceased && !value.not_applicable">
                <b-col>
                  <fieldset class="form-group required">
                    <legend></legend>
                    <label for="hasSiblings">CPF</label>
                    <b-form-input
                      v-model="value.formData.cpf"
                      :state="
                        value.formData.cpf
                          ? verificarCpf(value.formData.cpf)
                          : null
                      "
                      type="text"
                      name="cpf"
                      label="CPF"
                      v-mask="'###.###.###-##'"
                      placeholder=""
                    ></b-form-input>
                  </fieldset>
                </b-col>
                <b-col></b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProfilePhoto from "@/components/ProfilePhoto.vue";
import StandardInput from "@/components/inputs/StandardInput.vue";
import httpRda from "../../../http-rda";
import getAddressByCep from "../../../services/getAddressByCep";
import getStateNameByAcronym from "../../../utils/getStateNameByAcronym";
import { validateCPF } from "../../../utils/validateCPF";
import LoadingList from "@/components/LoadingList.vue";
import RequiredFieldsMessage from "@/components/RequiredFieldsMessage.vue";

export default {
  name: "Filiation",
  components: {
    ProfilePhoto,
    StandardInput,
    LoadingList,
    RequiredFieldsMessage,
  },

  props: ["value", "nameStudantValidate", "studentAddressId"],

  computed: {
    ...mapGetters({
      statesList: "shared/states",
    }),
    states() {
      return [...this.statesList.map((c) => c.name), "Não se aplica"];
    },
  },

  data() {
    return {
      loadingForm: true,
      loadingCep: false,
      accordionStates: {},
      sameAddress: [],
      enrollment_id: this.$route.params.id,
      contractorList: [],
      contractorListBkp: [],
      alphabet: ["A", "B"],
      formInputs: {
        relationship: "",
        is_guardian: "",
        is_pedagogical_contact: false,
        is_financial_contact: false,
        is_address_same_student: false,
        photo: "",
        photoPreview: null,
        name: "",
        occupation: "",
        workplace: "",
        nationality: "",
        country_origin: "",
        talents: "",
        phone1: "",
        phone2: "",
        phone_commercial: "",
        email: "",
        allow_email: false,
        cpf: "",
        Address: {
          id: null,
          cep: null,
          number: null,
          complement: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
          country: null,
        },
        shouldUpdatePhoto: true,
      },

      formInputsDeceased: {
        relationship: "",
        is_guardian: "Não",
        is_pedagogical_contact: "Não",
        is_financial_contact: "Não",
        is_address_same_student: false,
        photo: "",
        photoPreview: null,
        name: "",
        occupation: "not applicable",
        workplace: "not applicable",
        nationality: "not applicable",
        country_origin: "not applicable",
        talents: "not applicable",
        phone1: "not applicable",
        phone2: "not applicable",
        phone_commercial: "not applicable",
        email: "not_applicable@notapplicable.com",
        allow_email: "Não",
        cpf: "00000000000",
        Address: {
          id: undefined,
          cep: null,
          number: null,
          complement: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
          country: null,
        },
        shouldUpdatePhoto: true,
      },

      formInputsNotApplicable: {
        relationship: "",
        is_guardian: "Não",
        is_pedagogical_contact: "Não",
        is_financial_contact: "Não",
        is_address_same_student: false,
        photo: "",
        photoPreview: null,
        name: "Não Há",
        occupation: "not applicable",
        workplace: "not applicable",
        nationality: "not applicable",
        country_origin: "not applicable",
        talents: "not applicable",
        phone1: "not applicable",
        phone2: "not applicable",
        phone_commercial: "not applicable",
        email: "not_applicable@notapplicable.com",
        allow_email: "Não",
        cpf: "00000000000",
        Address: {
          id: undefined,
          cep: null,
          number: null,
          complement: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
          country: null,
        },
        shouldUpdatePhoto: true,
      },

      options: {
        relationships: ["Pai", "Mãe"],
        boolean: ["Sim", "Não"],
      },
    };
  },

  methods: {
    verificarCpf(cpf) {
      return validateCPF(cpf);
    },

    updateAccordionState(index) {
      const shouldBeOpen =
        this.value[index] && this.value[index].previousInformed === "Não";
      this.$set(this.accordionStates, index, shouldBeOpen);
    },

    setPreviousSelected(value, formIndex) {
      if (value === "Não") {
        this.value[formIndex].formData = { ...this.formInputs };
      } else {
        this.value[formIndex].formData = {};
      }

      this.updateAccordionState(formIndex);
      this.updateContractorList();
    },

    ...mapGetters({
      student: "enrollment/getStudent",
    }),

    onSelectFiliation(selected, currentIndex) {
      this.value[currentIndex].formData = { ...selected };
      this.updateContractorList();
    },

    updateContractorList() {
      const selectedIds = this.value
        .filter(
          (filiation) =>
            filiation.previousInformed === "Sim" &&
            filiation.formData &&
            filiation.formData.id
        )
        .map((filiation) => filiation.formData.id);

      this.contractorList = this.contractorListBkp.filter(
        (contractor) => !selectedIds.includes(contractor.id)
      );
    },

    async getAddress(cep, filiationIndex) {
      this.loadingCep = true;

      await getAddressByCep(cep)
        .then((resp) => {
          this.value[filiationIndex].formData.Address.state =
            getStateNameByAcronym(resp.uf);
          this.value[filiationIndex].formData.Address.city = resp.localidade;
          this.value[filiationIndex].formData.Address.neighborhood =
            resp.bairro;
          this.value[filiationIndex].formData.Address.street =
            resp.logradouro;
        })
        .catch((err) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "error",
            title: err.message,
          });
        });

      this.loadingCep = false;
    },

    resetAddressForm(index) {
      this.value[index].formData.is_address_same_student =
        this.sameAddress[index];

      this.value[index].formData.Address = {
        id: null,
        cep: null,
        number: null,
        complement: null,
        street: null,
        neighborhood: null,
        city: null,
        state: null,
        country: null,
      };
    },

    setDeceased(value, index) {
      if (value === true) {
        this.value[index].not_applicable = false;
        this.value[index].formData = {
          ...this.formInputsDeceased,
          id: this.value[index].formData.id,
        };
        this.value[index].deceased = true;
      } else {
        this.value[index].formData = {
          ...this.formInputs,
          id: this.value[index].formData.id,
        };
        this.value[index].deceased = false;
      }
    },

    setNotApplicable(value, index) {
      if (value === true) {
        this.$swal
          .fire({
            title: "Atenção",
            text: "Importante: esta opção é exclusiva para crianças com o registro de apenas um responsável na certidão de nascimento.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.value[index].deceased = false;
              this.value[index].formData = {
                ...this.formInputsNotApplicable,
                id: this.value[index].formData.id,
              };
              this.value[index].not_applicable = true;
            } else {
              this.value[index].not_applicable = false;
            }
          });
      } else {
        this.value[index].formData = {
          ...this.formInputs,
          id: this.value[index].formData.id,
        };
        this.value[index].not_applicable = false;
      }
    },

    positionAlphabet(index) {
      return this.alphabet[index];
    },

    defineTypeOfFiliate() {
      for (const filiation of this.value) {
        if (filiation.formData.ResponsibleTypes) {
          for (const key of filiation.formData.ResponsibleTypes) {
            switch (key.type) {
              case "filiation a":
                return "Filiação B";

              case "filiation b":
                return "Filiação A";
            }
          }
        }

        switch (filiation.type) {
          case "Filiação A":
            return "Filiação B";
        }
      }
      return "Filiação A";
    },

    addFiliate() {
      const newIndex = this.value.length;
      this.value.push({
        previousInformed: false,
        formData: { ...this.formInputs },
        type: this.defineTypeOfFiliate(),
        deceased: false,
        not_applicable: false,
      });
      this.updateAccordionState(newIndex);
    },

    setNewPhoto(photo, index) {
      const bodyFormData = new FormData();
      bodyFormData.append("file", photo);
      this.value[index].formData.photo = bodyFormData;
      this.value[index].formData.photoPreview = photo;
      this.value[index].formData.shouldUpdatePhoto = false;
    },

    defineIfIsSameAddressOfStudent(filiation) {
      if (filiation.formData.address_id !== this.studentAddressId) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    defineIfIsDeceased(filiation) {
      if (
        filiation.formData.cpf.replace(/[^a-zA-Z0-9 ]/g, "") == "00000000000" &&
        filiation.formData.name !== "Não Há"
      ) {
        return true;
      } else {
        return false;
      }
    },

    defineIfIsNotApplicable(filiation) {
      if (
        (filiation.formData.cpf.replace(/[^a-zA-Z0-9 ]/g, "") ==
          "00000000000" &&
          filiation.formData.name == "Não Há") ||
        filiation.formData.relationship == "" ||
        !filiation.formData.relationship
      ) {
        return true;
      } else {
        return false;
      }
    },

    async loadFiliates() {
      if (this.value.length == 0) {
        this.addFiliate();
      } else {
        for (const filiation of this.value) {
          if (filiation.formData !== undefined) {
            for (const key in filiation.formData) {
              if (filiation.formData[key] === true) {
                filiation.formData[key] = "Sim";
              } else if (filiation.formData[key] === false) {
                filiation.formData[key] = "Não";
              }
            }

            if (
              filiation.formData.cpf.replace(/[^a-zA-Z0-9 ]/g, "") ==
                "00000000000" &&
              filiation.formData.name !== "Não Há"
            ) {
              filiation.deceased = true;
              filiation.not_applicable = false;
            } else if (
              filiation.formData.name == "Não Há" &&
              filiation.formData.cpf.replace(/[^a-zA-Z0-9 ]/g, "") ==
                "00000000000"
            ) {
              filiation.not_applicable = true;
              filiation.deceased = false;
            } else {
              filiation.deceased = false;
              filiation.not_applicable = false;
            }
          }
        }

        this.value.map((filiation, index) => {
          if (filiation.previousInformed === "Não") {
            filiation.formData.shouldUpdatePhoto = !filiation.formData.photo;
          } else {
            filiation.formData.shouldUpdatePhoto = false;
          }

          if (
            filiation.formData !== undefined &&
            filiation.formData.ResponsibleTypes
          ) {
            filiation.formData.ResponsibleTypes.find((responsibleType) => {
              switch (responsibleType.type) {
                case "filiation a":
                  this.value[index].type = "Filiação A";
                  this.value[index].formData.is_address_same_student =
                    this.defineIfIsSameAddressOfStudent(filiation);
                  this.value[index].deceased =
                    this.defineIfIsDeceased(filiation);
                  this.value[index].not_applicable =
                    this.defineIfIsNotApplicable(filiation);
                  break;

                case "filiation b":
                  this.value[index].type = "Filiação B";
                  this.value[index].formData.is_address_same_student =
                    this.defineIfIsSameAddressOfStudent(filiation);
                  this.value[index].deceased =
                    this.defineIfIsDeceased(filiation);
                  this.value[index].not_applicable =
                    this.defineIfIsNotApplicable(filiation);
                  break;
              }
            });
          }
        });

        this.value.forEach((filiation) => {
          if (
            filiation.formData !== undefined &&
            filiation.formData.relationship &&
            !this.options.relationships.includes(
              filiation.formData.relationship
            )
          ) {
            filiation.formData.relationship = "";
          }
        });
      }

      this.value.forEach((_, index) => {
        this.updateAccordionState(index);
      });

      this.updateContractorList();

      this.loadingForm = false;
    },

    async getContractors() {
      await httpRda
        .get(`/enrollments/${this.enrollment_id}/responsibles`)
        .then((response) => {
          this.contractorList = response.data.responsibles
            .filter((responsible) =>
              responsible.ResponsibleTypes[0].type.includes("contractor")
            )
            .map((contractor) => {
              return {
                id: contractor.id,
                name: contractor.name,
              };
            });

          this.contractorListBkp = [...this.contractorList];
        });
    },
  },

  watch: {
    sameAddress: function (newValue) {
      newValue.map((value, index) => {
        this.value[index].formData.is_address_same_student = value;
      });
    },

    studentAddressId(val) {
      if (val !== null && val !== undefined) {
        this.value.forEach((filiation, index) => {
          if (filiation.formData !== undefined && filiation.formData.ResponsibleTypes) {
            this.value[index].formData.is_address_same_student =
              this.defineIfIsSameAddressOfStudent(filiation);
            this.sameAddress[index] =
              this.defineIfIsSameAddressOfStudent(filiation);
          }
        });
      }
    },
  },

  mounted() {},

  created() {
    this.getContractors().then(() => {
      if (this.value.length === 0) {
        this.addFiliate();
        this.addFiliate();
      } else if (this.value.length === 1) {
        this.addFiliate();
      }

      this.loadFiliates();
    });

    this.value.map((filiation, index) => {
      if (filiation.formData !== undefined) {
        if (filiation.formData.address_id !== this.studentAddressId) {
          this.sameAddress[index] = "Não";
        } else {
          this.sameAddress[index] = "Sim";
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.wrap-informed {
  position: relative;
  z-index: 10;
}
.information {
  position: relative !important;
}
.wrap-add {
  padding-top: 40px;
  position: relative;
  z-index: 0;

  .add {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      font-size: 16px !important;
      position: relative;
      top: -1px;
    }
  }
}

.title-collapse {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  h5 {
    flex: 1;
  }
}
.btn-remove {
  background: transparent;
  height: 47px;
  border: 0;

  svg {
    font-size: 16px;
    fill: red;
  }
}

.group {
  border-top: 1px solid #b3b3b3;
  padding-top: 30px;
  margin-top: 30px;
}
</style>
